
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#2c2c30","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2070.635-1766.05a5.494 5.494 0 002.188-.439 5.674 5.674 0 001.807-1.226 5.858 5.858 0 001.225-1.807 5.407 5.407 0 00.444-2.183 5.466 5.466 0 00-.444-2.2 5.8 5.8 0 00-3.033-3.03 5.619 5.619 0 00-4.38 0 5.708 5.708 0 00-1.806 1.227 5.824 5.824 0 00-1.221 1.807 5.466 5.466 0 00-.444 2.2 5.407 5.407 0 00.444 2.183 5.9 5.9 0 001.221 1.803 5.6 5.6 0 001.807 1.226 5.529 5.529 0 002.192.439zm0 1.4a6.83 6.83 0 01-2.734-.552 7.162 7.162 0 01-3.77-3.77 7.109 7.109 0 010-5.469 7.074 7.074 0 011.524-2.248 7.241 7.241 0 012.25-1.524 7.039 7.039 0 015.464 0 7.149 7.149 0 013.77 3.778 7.1 7.1 0 010 5.464 7.162 7.162 0 01-3.77 3.77 6.83 6.83 0 01-2.734.548zm9.355 3.415a1.054 1.054 0 01-.376-.068.833.833 0 01-.317-.215l-5-4.99 1.406-1.377 4.98 4.99a.889.889 0 01.205.317 1.05 1.05 0 01-.054.864.888.888 0 01-.342.352.987.987 0 01-.502.127z"}})])])
          )
        }
      }
    